import React from 'react';
import { X } from 'lucide-react';
import { Card, CardContent, CardHeader } from './ui/card';

const DemoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm animate-fade-in">
      <Card className="relative w-full max-w-4xl mx-4 bg-slate-900/95 border-slate-700 shadow-2xl animate-scale-in">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 text-slate-400 hover:text-white transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        <CardHeader className="p-8 pb-6">
          <h2 className="text-3xl font-bold text-white mb-2">Watch UNIFYTY Demo</h2>
          <p className="text-slate-400">
            See how UNIFYTY transforms security operations in minutes.
          </p>
        </CardHeader>

        <CardContent className="p-8 pt-0">
          {/* Video Placeholder */}
          {/* Video Player */}
          <div className="relative aspect-video bg-slate-900 rounded-xl overflow-hidden border border-slate-700 shadow-2xl">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/2HvS9qWC7Nw?autoplay=1&rel=0"
              title="UNIFYTY Platform Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
            ></iframe>
          </div>

          {/* Key Features Below Video */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
            <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
              <div className="text-cyan-400 font-bold text-lg mb-1">95%</div>
              <div className="text-slate-300 text-sm">Less Alert Noise</div>
            </div>
            <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
              <div className="text-blue-400 font-bold text-lg mb-1">10x</div>
              <div className="text-slate-300 text-sm">Faster Detection</div>
            </div>
            <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4">
              <div className="text-purple-400 font-bold text-lg mb-1">110+</div>
              <div className="text-slate-300 text-sm">Integrations</div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DemoModal;